import { QueryClient } from "@tanstack/react-query";
import { ApiRequestError } from "./api";

export const queryKeys = {
  account: (tenantKey: string) => ["account", tenantKey] as const,
  library: (tenantKey: string) => ["operator-library", tenantKey] as const,
  schedule: (tenantKey: string) => ["schedule", tenantKey] as const,
  session: (tenantKey: string, sessionId: string) => ["session", tenantKey, sessionId] as const,
  roomLibrary: (tenantKey: string, roomId: string) => ["room-library", tenantKey, roomId] as const,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        if (error instanceof ApiRequestError && [401, 403, 404].includes(error.status)) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
